/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IDmpConfiguration } from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import { ICustomVariables } from "../data-layer/data-layer";
import { StackContext } from "../context";
import { SiteNativeTemplate } from "../native/native";
import searchPageProps from "./pages/searchresultpage";
import itemPageProps from "./pages/itempage";

function createCustomPageProps(c: StackContext) {
  let dmpProps: any[] = [
    {
      name: "Etuovi_Uusikäyttäjä",
      resolve: () => {
        return window.digitalData.user[0].segment.credentials.includes(
          "newuser"
        )
          ? "New user"
          : "";
      },
    },
    {
      name: "Etuovi_Vahtivoimassa",
      resolve: () => {
        return window.digitalData.user[0].profile[0].profileInfo.settings.includes(
          "eoWatchdogActive"
        )
          ? "Vahti voimassa"
          : "";
      },
    },
  ];

  if (
    (c.services.dataLayerService?.dataLayer.pageType as unknown as string) ===
    "searchresultpage"
  ) {
    dmpProps = [...dmpProps, ...searchPageProps];
  }

  if (
    (c.services.dataLayerService?.dataLayer.pageType as unknown as string) === "itempage"
  ) {
    dmpProps = [...dmpProps, ...itemPageProps];
  }
  return {
    page: dmpProps,
  };
}

const dmp: IDmpConfiguration<ICustomVariables, SiteNativeTemplate> = {
  enabled: true,
  siteId: "seont7td4",
  defaults: { collectOnPageLoad: false },
  resolveCustomProps: createCustomPageProps,
};

export default dmp;
